<div class="cil-pin">
  <img [pin-type]="pinType" [margin-left]="width">
</div>
<div #graph class="cil-bar">
  <img class="bg" src="assets/images/bbreport_bar.png">
  <img class="fg" src="assets/images/bbreport_bar.png" [clip-right]="width">
</div>
<div class="cil-wrap">
  <div class="box-middle">
    <div class="columns">Lv.1</div>
    <div class="columns">Lv.2</div>
    <div class="columns">Lv.3</div>
  </div>
</div>
